export default __webpack_public_path__ + "7d9d5b02505b0cfa83ded444ae6a2a10.svg";